export default "__VITE_ASSET__0c32af86__"